import React from 'react';
import { NavLink } from 'react-router-dom';
import '../../css/Mypage/sideTab.css';
import { ReactComponent as ArrowRight } from '../../assets/icons/svg/arrowLeft.svg';

function SideTab({ name, id, tabs }) {
  return (
    <div className='mypage-user-menu'>
      <div className='mypage-user-info'>
        <h2 className='mypage-user-name'>{name}님</h2>
        <p className='mypage-user-id'>{id}</p>
        <p className='mypage-fixed-text'>세상의 모든 크루즈 여행, 와우크루즈와 함께 하세요.</p>
      </div>

      <div className='mypage-user-menu-tab-wrapper'>
        {tabs.map(tabGroup => (
          <div className='mypage-user-menu-tab' key={tabGroup.groupTitle}>
            <p className='tab-title'>{tabGroup.groupTitle}</p>
            <div className='tab-link-wrapper'>
              {tabGroup.items.map(tabItem => (
                <NavLink
                  key={tabItem.id}
                  to={tabItem.path}
                  className={({ isActive }) => `tab-link${isActive ? ' active' : ''}`}
                >
                  <span className='tab-link-label'>
                    <span className='tab-link-name'>{tabItem.name}</span>
                    {Number(tabItem.count) > 0 ? (
                      <span className='tab-link-count'>{Number(tabItem.count)}건</span>
                    ) : null}
                  </span>
                  <ArrowRight className='arrowRight' />
                </NavLink>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SideTab;
